<template>
  <div>
    <el-dialog
      title="音频信息"
      :visible.sync="visible"
      width="80%"
      class="audioDialog"
      @close="closeDialog"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      append-to-body
      :class="visible ? 'flip-in-hor-bottom' : ''"
    >
      <div class="container-header" style="margin-bottom: 20px">
        <span style="color: #5f676c; font-size: 18px">{{
          curData ? curData.position : ""
        }}</span>
        <span style="color: #5f676c; font-size: 18px; margin-left: 10px">{{
          curData ? curData.warningTime : ""
        }}</span>
        <span style="color: #5f676c; font-size: 18px; margin-left: 10px">{{
          yysyResult
        }}</span>
        <!--                <span style="color: #5f676c;margin-left: 5px;font-size: 18px;">{{curData ? curData.maxEnergy : ''}}</span>-->
        <!--                <span style="color: #5f676c;font-size: 18px;margin-left: 50px">声纹识别：</span>-->
        <!--                <span style="color: #5f676c;margin-left: 5px;font-size: 18px;">{{yysyResult}}</span>-->
        <el-button
          size="mini"
          class="handle-btn"
          style="float: right"
          @click="clickSolveBtn"
          >故障处理</el-button
        >
      </div>
      <div style="clear: both"></div>
      <div v-show="loadStatus === 'success'">
        <div class="player-header">原始音频</div>
        <player
          ref="upPlayer"
          title="原始音频"
          @status-changed="playerStatusChanged"
        />

        <div class="audio-btn">
          <el-image
            title="停止"
            :src="require('@/assets/player/stop3.png')"
            class="player-btn"
            fit="contain"
            @click="stopAudio('up')"
          ></el-image>
          <img
            alt="播放"
            title="播放"
            :src="
              this.upPlaying
                ? require('@/assets/player/play2.png')
                : require('@/assets/player/play3.png')
            "
            class="player-btn"
            @click="playAudio('up')"
          />
          <el-image
            title="暂停"
            :src="require('@/assets/player/pause3.png')"
            class="player-btn"
            fit="contain"
            @click="pauseAudio('up')"
          ></el-image>
          <el-image
            title="下载"
            :src="require('@/assets/player/download3.png')"
            class="player-btn"
            fit="contain"
            @click="downloadAudio"
          ></el-image>
        </div>

        <div class="player-header">降噪音频</div>
        <player
          ref="downPlayer"
          title="降噪音频"
          @interval-selected="intervalSelected"
          @status-changed="playerStatusChanged"
        />

        <div class="audio-btn">
          <el-image
            title="停止"
            :src="require('@/assets/player/stop3.png')"
            class="player-btn"
            fit="contain"
            @click="stopAudio('down')"
          ></el-image>
          <img
            title="播放"
            alt=""
            :src="
              this.downPlaying
                ? require('@/assets/player/play2.png')
                : require('@/assets/player/play3.png')
            "
            class="player-btn"
            @click="playAudio('down')"
          />
          <el-image
            title="暂停"
            :src="require('@/assets/player/pause3.png')"
            class="player-btn"
            fit="contain"
            @click="pauseAudio('down')"
          ></el-image>
          <el-image
            title="下载"
            :src="require('@/assets/player/download3.png')"
            class="player-btn"
            fit="contain"
            @click="downloadAudio"
          ></el-image>
          <el-image
            title="声纹建模"
            :src="require('@/assets/player/modeling3.png')"
            class="player-btn"
            fit="contain"
            @click="modeling"
          ></el-image>
        </div>
      </div>

      <div
        v-show="loadStatus === 'loading'"
        style="
          height: 180px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #b4b4b4;
          font-size: 20px;
        "
      >
        加载中...
      </div>
      <div
        v-show="loadStatus === 'failed'"
        style="
          height: 350px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #b4b4b4;
          font-size: 20px;
        "
      >
        加载音频失败
      </div>

      <!--            <div class="bottom-bar">-->
      <!--                <el-button type="primary" size="mini" @click="playAudio">{{ btnText }}</el-button>-->
      <!--                <el-button type="primary" size="mini" @click="clickModeling">声纹建模</el-button>-->
      <!--            </div>-->
      <!--    <div class="bottomCon">-->
      <!--      <el-select v-model="curStatus" @change="statusChange">-->
      <!--        <el-option-->
      <!--          v-for="item in options"-->
      <!--          :key="item.value"-->
      <!--          :label="item.label"-->
      <!--          :value="item.value"-->
      <!--        >-->
      <!--        </el-option>-->
      <!--      </el-select>-->
      <!--    </div>-->
    </el-dialog>
    <modeling-dialog ref="modelingDialog"></modeling-dialog>
    <solve-dialog ref="solveDialog"></solve-dialog>
  </div>
</template>

<script>
import player from "../components/audio-player.vue";
import modelingDialog from "../components/modelingDialog.vue";
import SolveDialog from "../pages/home/realTime/solveDialog.vue";

export default {
  components: { SolveDialog, player, modelingDialog },
  data() {
    return {
      visible: false,
      btnText: "播放",
      fileName: "",
      curData: null,
      loadStatus: "loading",
      selectedStartPos: 0,
      selectedEndPos: 0,
      upPlaying: false,
      downPlaying: false,
      wavUrl: "",
      yysyResult: "",
      options: [
        { value: 1, label: "未处理" },
        { value: 2, label: "忽略" },
        { value: 3, label: "已处理" },
      ],
    };
  },
  methods: {
    //关闭dialog
    closeDialog() {
      this.btnText = "播放";
    //   this.$refs.upPlayer.waveSurfer.pause();
    //   this.$refs.upPlayer.waveSurfer.destroy();
    //   this.$refs.downPlayer.waveSurfer.pause();
    //   this.$refs.downPlayer.waveSurfer.destroy();
    },
    show(data) {
      console.log("data", data);
      this.yysyResult = "";
      this.visible = true;
      this.fileName = new Date(data.warningTime).getTime() / 1000 + ".1.wav";
      this.curData = data;
      const params = {
        sensorId: data.sensorId,
        warningTime: data.warningTime,
      };
      this.wavUrl =
        "/api/warning/" +
        this.curData.sensorId +
        "/" +
        new Date(this.curData.warningTime).getTime() / 1000;
      this.loadStatus = "loading";
      this.checkYYSY();
      //加载音频文件
      this.$api.sensor.getWarningAudio(params).then(res => {
        if (res.success) {
          this.loadStatus = "success";
          this.$nextTick(() => {
            //nextTick确保dom从隐藏变为显示后，再初始化播放器
            if (!this.$refs.upPlayer.waveSurfer) {
                  this.$refs.upPlayer.initPlayer();
                  this.$refs.downPlayer.initPlayer();
              }
            this.$refs.upPlayer.waveSurfer.empty();
            this.$refs.downPlayer.waveSurfer.empty();

          //   this.$refs.upPlayer.initPlayer();
          //   this.$refs.downPlayer.initPlayer();
            this.$refs.upPlayer.waveSurfer.load(this.wavUrl + ".1.wav");
            this.$refs.downPlayer.waveSurfer.load(this.wavUrl + ".2.wav");
          });
        } else {
          this.loadStatus = "failed";
          this.$message.error(res.msg);
        }
      });
    },
    //检查是否有语音识别
    checkYYSY() {
      this.$api.yysy.evaluate({ warningId: this.curData.id }).then((res) => {
        if (res.success) {
          this.yysyResult = res.data;
        }
      });
    },
    //改变状态
    statusChange(status) {
      this.$store.state.loading = true;

      const params = {
        id: this.curData.id,
        status: status,
      };
      this.$api.warning
        .status(params)
        .then((res) => {
          this.$store.state.loading = false;

          if (res.code == 200) {
            this.$message.success("修改成功");
            this.$emit("changeWarningList");
          }
        })
        .catch(() => {
          this.$store.state.loading = false;
        });
    },
    intervalSelected(startPos, endPos) {
      console.log("intervalSelected", startPos, endPos);
      this.selectedStartPos = startPos;
      this.selectedEndPos = endPos;
    },
    //播放或暂停
    playAudio(side) {
      if (side === "up") {
        if (!this.$refs.upPlayer.waveSurfer) {
          return;
        }
        this.$refs.upPlayer.play();
        this.$refs.downPlayer.waveSurfer.pause();
      } else {
        if (!this.$refs.downPlayer.waveSurfer) {
          return;
        }
        this.$refs.downPlayer.play();
        this.$refs.upPlayer.waveSurfer.pause();
      }
    },
    stopAudio(side) {
      if (side === "up") {
        if (!this.$refs.upPlayer.waveSurfer) {
          return;
        }
        this.$refs.upPlayer.stop();
      } else {
        if (!this.$refs.downPlayer.waveSurfer) {
          return;
        }
        this.$refs.downPlayer.stop();
      }
    },
    pauseAudio(side) {
      if (side === "up") {
        if (!this.$refs.upPlayer.waveSurfer) {
          return;
        }
        this.$refs.upPlayer.waveSurfer.pause();
      } else {
        if (!this.$refs.downPlayer.waveSurfer) {
          return;
        }
        this.$refs.downPlayer.waveSurfer.pause();
      }
    },
    downloadAudio() {
      if (!this.curData) {
        return;
      }
      let a = document.createElement("a");
      a.setAttribute("download", this.curData.warningTime + "_原始.wav");
      a.href = this.wavUrl + ".1.wav";
      a.click();
      a.setAttribute("download", this.curData.warningTime + "_过滤.wav");
      a.href = this.wavUrl + ".2.wav";
      a.click();
    },
    //播放器状态改变
    playerStatusChanged(title, status) {
      console.log("playerStatusChanged", title, status);
      if (title === "原始音频") {
        this.upPlaying = status === "playing";
      } else if (title === "降噪音频") {
        this.downPlaying = status === "playing";
      }
    },
    clickSolveBtn() {
      this.$refs.solveDialog.show(this.curData.id, this.curData.status + "", this.curData.description);
    },
    //语音建模
    modeling() {
      // this.$emit("clickModeling", this.curData);
      if (this.selectedEndPos - this.selectedStartPos < 1600) {
        this.$message.warning("请在波形中选择一个大于0.2秒的区间");
        return;
      }
      let params = {
        startPos: this.selectedStartPos,
        endPos: this.selectedEndPos,
        samplePath:
          "/warning/" +
          this.curData.sensorId +
          "/" +
          new Date(this.curData.warningTime).getTime() / 1000 +
          ".2.wav",
        edgeId: this.curData.edgeId,
        sensorId: this.curData.sensorId,
      };
      this.$refs.modelingDialog.show(params);
    },
  },
};
</script>

<style lang="less" scoped>
.bottom-bar {
  margin-top: 20px;
}

.audioDialog {
  /deep/ .el-dialog__body {
    padding: 25px 20px !important;
  }

  /deep/ .el-input {
    width: 94px !important;
  }
}

//添加动画
.flip-in-hor-bottom {
  animation: flip-in-hor-bottom 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@keyframes flip-in-hor-bottom {
  0% {
    transform: rotateX(80deg);
    opacity: 0;
  }

  100% {
    transform: rotateX(0);
    opacity: 1;
  }
}

.audio-btn {
  background-color: rgb(25, 26, 25);
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.player-btn {
  width: 25px;
  height: 25px;
  margin-right: 10px;
  cursor: pointer;
}

.player-header {
  width: 100%;
  height: 30px;
  background: var(--audio-text-bg);
  font-size: 12px;
  font-weight: 400;
  color: #b4b4b4;
  padding: 6px 0 6px 8px;
  box-sizing: border-box;
}

.handle-btn {
  background: #44d7b6;
  border-radius: 0.125rem;
  color: #ffffff;
  border: none;
  cursor: pointer;
  font-size: 0.875rem;
}
</style>



// WEBPACK FOOTER //
// src/components/warningAudioDialog.vue